import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { colors } from "../../theme/theme";
import dayjs from "dayjs";

const ReceiverMsg = ({ msg }) => {
  return (
    <Box
      sx={{
        backgroundColor: "rgba(247,132,25, 0.05)",
        borderRadius: "14px",
        p: 2,
        mb: 2,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        maxWidth: "80%",
      }}
    >
      <Stack direction="row" spacing={1} maxWidth={"85%"}>
        <img
          src={
            msg?.sender?.avatar || require("../../assets/images/default.jpg")
          }
          alt="Avatar"
          style={{ width: "35px", height: "35px", borderRadius: "50%" }}
        />
        <Stack direction={"column"}>
          <Typography
            sx={{
              color: colors.primary,
              fontFamily: "Mulish-Bold",
              fontSize: "14px",
            }}
          >
            {msg?.sender?.firstName}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Mulish-Regular",
              fontSize: "13px",
              color: colors.primary,
            }}
          >
            {msg?.message}
          </Typography>
        </Stack>
      </Stack>

      <Typography
        sx={{
          fontFamily: "Mulish-Light",
          fontSize: "12px",
          color: "#B0B0B0",
        }}
      >
        {dayjs(msg?.createdAt).fromNow()}
      </Typography>
    </Box>
  );
};

export default ReceiverMsg;
